import { APIClient } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { UserCertification } from '@frontend/certificate/types';

export class CertificationClient extends APIClient {
    public static readonly endpoint = '/certificate-api/v1';

    public static async postGetProductCertification(accountId: string, userId: string, ids: string[], withCredentials?: Token): Promise<UserCertification> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/users/${userId}/product-certification`, { ids: ids }, true, withCredentials);
        return await this.handleResponse<UserCertification>(response);
    }
}
